import Heading from "hardcover-ui/components/Heading";
import Icon from "hardcover-ui/components/Icon";
import TextLink from "hardcover-ui/components/TextLink";
import { tagIconFor } from "lib/genres/findHeader";
import { TagSerializersTagByline } from "types/serializers";

export interface PageProps {
  tag: TagSerializersTagByline;
}

export default function TagHeader({ tag }: PageProps) {
  const icon = tagIconFor(tag.tagCategory.slug);

  return (
    <div className="p-4">
      <p>
        <TextLink
          href={`/browse/tags/${tag.tagCategory.slug}`}
          className="flex flex-row items-center"
        >
          <Icon icon={icon} size="lg" className="mr-2" />
          <span className="capitalize">{tag.tagCategory.category}s</span>
        </TextLink>
      </p>
      <Heading
        level={1}
        variant="primary"
        size="lg"
        className="capitalize mt-2"
      >
        {tag.tag}
      </Heading>
    </div>
  );
}
